// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 364) return "css/build/cloudweb-20208-onprem-release-25-3-4.202602201412/errorPage.css";
	// return url for filenames based on template
	return undefined;
};